import { RawRolloverStatusRecord } from '../types/RolloverStatusTypes';

const transformRolloverStatusData = (
  data: RawRolloverStatusRecord[],
  forDownload: boolean = false
): any[] => {
  const result: any[] = [];
  let srNo = 1;
  data.forEach((record) => {
    result.push({
      ...(forDownload
        ? { 'Sr. No.': srNo.toString() }
        : {
            id:
              record.studentId ||
              `${record.enrollmentNumber}-${record.studentName}`
          }),
      'Enrollment Number': record.enrollmentNumber || '-',
      'Student Name': record.studentName || '-',
      'Current Grade': record.currentGrade || '-',
      'RollOver AY': record.rollOverAcademicYear || '-',
      'Rollover Grade': record.rolloverGrade || '-',
      'Rollover Form status': record.rolloverFormstatus || '-',
      'Rollover Submitted Date': record.rollOverSubmittedDate || '-',
      'Payment Scheme Selected': record.paymentScemeSelected || '-',
      'Full/First Installment Status':
        record.fullOrFirstInstallmentStatus || '-',
      'Enach/PDC Authorization Status':
        record.enachOrPDCAuthoriazationStatus || '-',
      'Father Name': record.fatherName || '-',
      'Father Email': record.fatherEmail || '-',
      'Father Contact': record.fatherPhoneNo || '-',
      'Mother Name': record.motherName || '-',
      'Mother Email': record.motherEmail || '-',
      'Mother Contact': record.motherPhoneNo || '-',
      'Guardian Name': record.guardianName || '-',
      'Guardian Email': record.guardianEmail || '-',
      'Guardian Contact': record.guardianPhoneNo || '-'
    });
    srNo++;
  });
  return result;
};

export { transformRolloverStatusData };
